import React from 'react';
import IconBase, { TIconBaseProps, Example as IconBaseExample } from './IconBase';

const MagnifyingGlassIcon = React.memo(function MagnifyingGlassIcon(
    props: TMagnifyingGlassIconProps,
): React.ReactElement {
    return (
        <IconBase aria-label="Magnifying Glass" {...props}>
            <path d="M19.5422 18.3584L13.9627 12.7789C14.8285 11.6596 15.2969 10.291 15.2969 8.85156C15.2969 7.12852 14.6244 5.51289 13.4084 4.29473C12.1924 3.07656 10.5725 2.40625 8.85156 2.40625C7.13066 2.40625 5.51074 3.07871 4.29473 4.29473C3.07656 5.51074 2.40625 7.12852 2.40625 8.85156C2.40625 10.5725 3.07871 12.1924 4.29473 13.4084C5.51074 14.6266 7.12852 15.2969 8.85156 15.2969C10.291 15.2969 11.6574 14.8285 12.7768 13.9648L18.3563 19.5422C18.3726 19.5586 18.392 19.5715 18.4134 19.5804C18.4348 19.5893 18.4577 19.5938 18.4809 19.5938C18.504 19.5938 18.5269 19.5893 18.5483 19.5804C18.5697 19.5715 18.5891 19.5586 18.6055 19.5422L19.5422 18.6076C19.5586 18.5913 19.5715 18.5718 19.5804 18.5505C19.5893 18.5291 19.5938 18.5062 19.5938 18.483C19.5938 18.4599 19.5893 18.4369 19.5804 18.4156C19.5715 18.3942 19.5586 18.3748 19.5422 18.3584ZM12.2547 12.2547C11.3438 13.1635 10.1363 13.6641 8.85156 13.6641C7.5668 13.6641 6.35938 13.1635 5.44844 12.2547C4.53965 11.3438 4.03906 10.1363 4.03906 8.85156C4.03906 7.5668 4.53965 6.35723 5.44844 5.44844C6.35938 4.53965 7.5668 4.03906 8.85156 4.03906C10.1363 4.03906 11.3459 4.5375 12.2547 5.44844C13.1635 6.35938 13.6641 7.5668 13.6641 8.85156C13.6641 10.1363 13.1635 11.3459 12.2547 12.2547Z" />
        </IconBase>
    );
});

export default MagnifyingGlassIcon;

// #region Types

export type TMagnifyingGlassIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function'
        ? () => <MagnifyingGlassIcon />
        : { ...IconBaseExample, render: MagnifyingGlassIcon };

// #endregion
